<script lang="ts">
  import DOMPurify from 'dompurify';
  import {marked} from 'marked';
  export let text: string;
  export let shadowLineBreaks: boolean = false;

  $: localText = shadowLineBreaks ? text.split('\n').join('   \n') : text;
  $: cleanText = DOMPurify.sanitize(localText, {ALLOWED_ATTR: ['target', 'href']});
</script>

<span class="markdown-body">{@html marked(cleanText)}</span>
